import { render, staticRenderFns } from "./Client.vue?vue&type=template&id=eca0fe9a&scoped=true&"
import script from "./Client.vue?vue&type=script&lang=ts&"
export * from "./Client.vue?vue&type=script&lang=ts&"
import style0 from "./Client.vue?vue&type=style&index=0&id=eca0fe9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca0fe9a",
  null
  
)

export default component.exports